import { convertCharterFullWidth } from "@lhd/utility";
import { ChangeEvent, FocusEvent, useState } from "react";
import { ICommonFieldProps } from "../../../../interfaces";

const NumberPhoneEditCell = (props: ICommonFieldProps) => {
  const { defaultValue, onChange } = props;
  const [value, setValue] = useState(String(defaultValue ?? ""));

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    // Only accept half-width/full-width digits and limit the phone number to
    // 10 digits. Full-width digits are kept until blur so IME input is safe.
    const nextValue = event.target.value
      .replace(/[^0-9０-９]/g, "")
      .slice(0, 10);

    setValue(nextValue);
    onChange?.(nextValue);
  };

  const handleBlur = (event: FocusEvent<HTMLInputElement>) => {
    const formattedValue = convertCharterFullWidth(value).replace(/\D/g, "");
    setValue(formattedValue);
    onChange?.(formattedValue);
  };

  return (
    <input
      className="input-field"
      type="text"
      inputMode="numeric"
      value={value}
      maxLength={10}
      pattern="[0-9]{10}"
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

export default NumberPhoneEditCell;
